import format from 'date-fns/format';
import isValid from 'date-fns/isValid';
import parse from 'date-fns/parse';
import parseISO from 'date-fns/parseISO';
import { DISPLAYED_DATE_FORMAT, DISPLAYED_DATE_LENGTH } from './date-picker.constants';

const CALENDAR_DATE_FORMAT = 'yyyy-MM-dd';
const MAX_TYPED_DIGITS = 8;

export const parseCalendarDate = (calendarDate?: string | null): Date | null => {
  const date = (calendarDate && parseISO(calendarDate)) || null;

  return date;
};

export const formatCalendarDate = (date: Date): string => {
  const calendarDate = format(date, CALENDAR_DATE_FORMAT);

  return calendarDate;
};

export const formatDisplayedDate = (date: Date | null): string => {
  const displayedDate = (date && format(date, DISPLAYED_DATE_FORMAT)) || '';

  return displayedDate;
};

export const maskTypedDate = (typedText: string): string => {
  const digits = typedText.replace(/\D/g, '').slice(0, MAX_TYPED_DIGITS);
  const dateParts = [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4)];
  const maskedDate = dateParts.filter(Boolean).join('/');

  return maskedDate;
};

export const countDigits = (text: string): number => {
  const digitCount = text.replace(/\D/g, '').length;

  return digitCount;
};

export const findPositionAfterDigits = (digitCount: number): number => {
  const separatorCount = [2, 4].filter((digitsBeforeSeparator) => digitCount > digitsBeforeSeparator).length;
  const position = digitCount + separatorCount;

  return position;
};

export const isTypedDateComplete = (typedDate: string): boolean => {
  const isComplete = typedDate.length === DISPLAYED_DATE_LENGTH;

  return isComplete;
};

export const parseTypedDate = (typedDate: string): Date | null => {
  const parsedDate = parse(typedDate, DISPLAYED_DATE_FORMAT, new Date());
  const isUsable = isTypedDateComplete(typedDate) && isValid(parsedDate);
  const date = (isUsable && parsedDate) || null;

  return date;
};
